import React, { createContext, useEffect, useReducer } from 'react'
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";

const initialValue = {
    shippings: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_SHIPPING_DATA': {
            return {
                ...state,
                shipping_list: action.payload,
            }
        }
        case 'UPDATE_SHIPPING_DATA': {
            let newData = state.shipping_list.shippings.map((seller) =>
                action.payload.id === seller.id ? action.payload : seller
            );

            let newState = {
                shippings: newData
            }

            return {
                ...state,
                shipping_list: newState,
            }
        }
        default: {
            return state
        }
    }
}

const ShippingContext = createContext({
    shipping_list: initialValue,
    getShipping: () => {},
    addShipping: () => {},
    updateShipping: () => {},
    getShippingById: () => {},
})

export const ShippingProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)

    const getShipping = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/shipping/shippings', options);

            dispatch({
                type: 'LOAD_SHIPPING_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }

    const getShippingById = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/shipping/shippings/'+id, options);

            return res.data;
        } catch (e) {
            console.error(e)
            return null;
        }
    }

    const addShipping = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/shipping/add', data, options);

            return res;
        } catch (e) {
            console.error(e)
            return e;
        }
    }

    const updateShipping = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/json',
                }
            }

            const res = await axios.post('/api/shipping/update', data, options);

            dispatch({
                type: 'UPDATE_SHIPPING_DATA',
                payload: res.data,
            })
            return res;
        } catch (e) {
            console.error(e)
            return e;
        }
    }

    useEffect(() => {
        getShipping();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if(state.shipping_list === undefined) {
        return <MatxLoading />
    }

    return (
        <ShippingContext.Provider
            value={{
                shipping_list: state.shipping_list,
                getShipping,
                addShipping,
                updateShipping,
                getShippingById,
            }}
        >
            {children}
        </ShippingContext.Provider>
    )
}

export default ShippingContext
